export enum LoanHelpCenterTopicIds {
	MANAGING_MY_LOAN = '7CofWLO8yA6GsOw0AWK0Io',
}
